
import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const replaceWhitespaceWithDash = (array: string[]) => {
   return array.map(item => item.replace(/[´çõí]/g, match => {
      switch (match) {
         case '´':
            return '';
         case 'ç':
            return 'c';
         case 'õ':
            return 'o';
         case 'í':
            return 'i';
         default:
            return match;
      }
   }).replace(/\s+/g, '-'));
}
export const formatter = new Intl.DateTimeFormat('pt-PT', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
});
export const getCurrentBrowser = () =>  {
  if (typeof navigator !== 'undefined') {
    
    const userAgent = navigator.userAgent;
    if (/opr\//i.test(userAgent) || /opera/i.test(userAgent)) return "Opera";
    if (/edg/i.test(userAgent)) return "Edge";
    if (/chrome|crios/i.test(userAgent) && !/edg/i.test(userAgent)) return "Chrome";
    if (/firefox|fxios/i.test(userAgent)) return "Firefox";
    if (/safari/i.test(userAgent) && !/chrome|crios|edg/i.test(userAgent)) return "Safari";
    if (/msie|trident/i.test(userAgent)) return "Internet Explorer";

    return "Unknown";
  }
  }
export const getUserCountry = () => {
   return new Promise((resolve, reject) => {
      if (typeof navigator !== 'undefined' && navigator.geolocation) {
        navigator.permissions.query({ name: "geolocation" }).then(permissionStatus => {
          if (permissionStatus.state === "granted") {
            navigator.geolocation.getCurrentPosition(
              position => {
                const { latitude, longitude } = position.coords;
                fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`)
                  .then(response => response.json())
                  .then(data => {
                    const country = data.countryName;
                    resolve(country);
                  })
                  .catch(error => {
                    reject(error);
                  });
              },
              error => {
                reject(error);
              }
            );
          } else if (permissionStatus.state === "prompt") {
            reject(new Error("Geolocation permission prompt"));
          } else if (permissionStatus.state === "denied") {
            reject(new Error("Geolocation permission denied"));
          }
        }).catch(error => {
          reject(error);
        });
      } else {
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
 }